import classNames from 'classnames';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import IconPlusLarge from '@picsart/icons/IconPlusLarge';
import IconRefresh from '@picsart/icons/IconRefresh';

import { Button } from '../../../core/Button/Button';
import UploadArea from '../../../core/UploadArea';

import { IUploadWidget } from './types';
import useStyles from './styles';

function UploadWidget({
  footer,
  heading,
  imgSrc,
  imgAlt,
  accept = '',
  retryBtnText = '',
  errorMessage = null,
  widgetClassName,
  imgContainerClassName,
  bannerContentClassName,
  handleUpload,
  uploadBtnText,
  onClickBtn,
}: IUploadWidget) {
  const classes = useStyles({ errorMessage });

  return (
    <div className={classNames({ [`${classes.widgetContainer}`]: errorMessage }, widgetClassName)}>
      <div className={bannerContentClassName}>
        <>
          {errorMessage ? (
            <div>{errorMessage}</div>
          ) : (
            <>
              {imgSrc && (
                <div className={classNames(classes.imgContainer, imgContainerClassName)}>
                  <LazyLoadImage src={imgSrc} alt={imgAlt} className={classes.image} />
                </div>
              )}
              <h1 className={classes.heading}>{heading}</h1>
            </>
          )}
        </>
      </div>

      <div>
        <UploadArea
          className={classes.stickyUpload}
          accept={accept}
          multiple={false}
          onUpload={handleUpload}
        >
          {errorMessage ? (
            <Button className={classes.button} variant="secondary">
              <IconRefresh />
              {retryBtnText}
            </Button>
          ) : (
            <Button className={classes.button} onClick={onClickBtn}>
              <IconPlusLarge />
              {uploadBtnText}
            </Button>
          )}
        </UploadArea>
        {footer && <div>{footer}</div>}
      </div>
    </div>
  );
}

export default UploadWidget;
